import { z } from 'zod';
export { ErrorCode } from './errors.js';
export const successEnvelope = (data) => ({ data });
export const apiErrorSchema = z.object({
    error: z.object({
        code: z.string(),
        message: z.string(),
        details: z.unknown().optional(),
    }),
});
//# sourceMappingURL=envelope.js.map